import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 3.475c0-.315.074-.628.292-.852C2.858 2.044 4.382.997 8 .997c3.618 0 5.142 1.047 5.707 1.626.22.224.293.537.293.852v9.522h-.989a.4.4 0 0 1-.011 0v1c0 .556-.448 1.006-1 1.006h-1c-.552 0-1-.45-1-1.006v-1H6v1c0 .556-.448 1.006-1 1.006H4c-.552 0-1-.45-1-1.006v-1H2V3.475Zm3 7.522c.549 0 1-.448 1-1 0-.553-.451-1-1-1-.549 0-1 .447-1 1 0 .552.451 1 1 1Zm6 0c.549 0 1-.448 1-1 0-.553-.451-1-1-1-.549 0-1 .447-1 1 0 .552.451 1 1 1Zm1-7v3H4v-3h8Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconMapBus16 = createIcon(IconComponent);